
<div>
    <span class="blog-txt-details">Compartir:</span>
    <share-it 
        :url="getUrl()"
        :text="getMetaDescription()"
        :share-config="iconConfig" 
        icons outline round />
</div>
